import { render, staticRenderFns } from "./ElemMobile.vue?vue&type=template&id=3c3702c4&"
import script from "./ElemMobile.vue?vue&type=script&lang=js&"
export * from "./ElemMobile.vue?vue&type=script&lang=js&"
import style0 from "./ElemMobile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports